import { IEntityStorySettingsGraphqlResponse } from '../../../types/storiesSettingsTypes';
import { ensureSettings as ensureSettingsQuery } from '../../graphQL/queries';

import { executeQuery } from './execute';

export async function ensureSettings(entityId: number): Promise<IEntityStorySettingsGraphqlResponse> {
  return executeQuery(ensureSettingsQuery, { entityId }) as Promise<IEntityStorySettingsGraphqlResponse>;
}
